import { ActivatedRouteSnapshot } from '@angular/router';
import { ConsumptionFilter, getInitialFilter } from '../../stores/consumption.store';
import { parse } from 'date-fns';
import * as Sentry from '@sentry/angular';

export const getFilterFromQueryParams = (route: ActivatedRouteSnapshot) => {
  const view = route.queryParamMap.get('view');
  const granularity = route.queryParamMap.get('granularity');
  const date = route.queryParamMap.get('date');
  const utilityType = route.queryParamMap.get('utilityType');
  const direction = route.queryParamMap.get('direction');
  const locationID = route.queryParamMap.get('locationID');
  const energyInterfaceID = route.queryParamMap.get('energyInterfaceID');

  const filterUpdate: ConsumptionFilter = getInitialFilter();
  if (view === 'line' || view === 'bar' || view === 'table') {
    filterUpdate.view = view;
  }
  if (
    granularity === 'YEAR' ||
    granularity === 'MONTH' ||
    granularity === 'WEEK' ||
    granularity === 'DAY'
  ) {
    filterUpdate.granularity = granularity;
  }
  if (date) {
    try {
      const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
      if (isNaN(parsedDate.getTime())) {
        throw new Error('Invalid date format for query parameter "date".');
      }
      filterUpdate.date = parsedDate;
    } catch (error) {
      Sentry.logger.error(
        Sentry.logger
          .fmt`Consumption graph: Invalid date format for query parameter "date": ${date}`,
        { error },
      );
    }
  }
  if (utilityType === 'ELECTRICITY' || utilityType === 'GAS') {
    filterUpdate.data.utilityType = utilityType;
  }
  if (direction === 'CONSUMPTION' || direction === 'PRODUCTION') {
    filterUpdate.data.direction = direction;
  }
  if (locationID) {
    filterUpdate.data.locationID = locationID;
  }
  if (energyInterfaceID) {
    filterUpdate.data.energyInterfaceID = energyInterfaceID;
  }

  return filterUpdate;
};
